var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-line-container"},[_c('svg',{staticClass:"svg-content",attrs:{"id":_vm.id,"viewBox":"0 0 500 400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/paywall/dashboard/Barcharts.vue